<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col">
        <h2>Convocation pour l'Assemblée Générale</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        Rappel des coordonnées de l'organisateur :
      </div>
      <div class="col-7"></div>
    </div>
    <div class="row mb-3">
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="col-5 font-italic"
        style="white-space: pre-line;"
        v-html="pdfContactDetails"
      ></div>
      <div class="col-7">
        <div style="margin-top: 58px; margin-left: 72px;">
          <span v-if="addresses.line1">{{ addresses.line1 }} <br /></span>
          <span v-if="addresses.line2">{{ addresses.line2 }} <br /></span>
          <span v-if="addresses.line3">{{ addresses.line3 }} <br /></span>
          <span v-if="addresses.line4">{{ addresses.line4 }} <br /></span>
          <span v-if="addresses.line5">{{ addresses.line5 }} <br /></span>
          <span v-if="addresses.line6">{{ addresses.line6 }} <br /></span>
          <span v-if="addresses.line7">{{ addresses.line7 }}</span>
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col">
        Copropriété : {{ building.name }}
        <div class="text-br-line font-italic">{{ building.address }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["building", "mandate", "countries", "pdfContactDetails", "recipient"],
  data() {
    return {
      addresses: {},
    };
  },
  created() {
    this.extractAddresses();
  },
  methods: {
    extractAddresses() {
      let line1 = "";
      if (this.recipient) {
        line1 = this.getPersonName({}, this.recipient);
        this.setAddress(this.recipient, line1);
      } else {
        line1 = this.getPersonName({ personId: this.mandate.building_owner_id });
        this.setAddress(this.getPerson({ personId: this.mandate.building_owner_id }), line1);
      }
    },
    setAddress(entity, line1) {
      var line2 = entity.complement;
      var line3 = entity.complement2;
      var line4 = entity.address;
      var line5 = "";
      var line6 = "";
      var line7 = "";
      let countryNotToShow = "FRANCE FR France Fr fr france";
      if (entity.zipcode) {
        line6 += entity.zipcode;
      }
      if (entity.city) {
        line6 += " " + entity.city;
      }
      if (entity.country && !countryNotToShow.includes(entity.country)) {
        line7 = this.getCountryName(entity.country);
      }
      this.addresses = {
        line1,
        line2,
        line3,
        line4,
        line5,
        line6,
        line7,
      };
    },
    getCountryName(countryCode) {
      let foundCountry = this.$_.find(this.countries, country => {
        return country.countryCode == countryCode.toUpperCase();
      });
      if (foundCountry) {
        return foundCountry.countryName;
      } else {
        return "";
      }
    },
  },
};
</script>
